<template>
  <div :class="{active}">
    <pause-circle-outlined v-if="playStat"/>
    <play-circle-outlined v-else/>
    <span>{{ name }}</span>
  </div>
</template>

<script setup lang="ts">
import {PauseCircleOutlined, PlayCircleOutlined} from "@ant-design/icons-vue";

defineProps<{ url: string, name: string, active: boolean, playStat: boolean }>()
</script>

<style scoped lang="sass">
div
  border-radius: 19px
  border: 1px solid var(--ant-color-border)
  line-height: 38px
  height: 38px
  padding: 0 12px 0 6px
  cursor: pointer
  display: flex
  flex-flow: row nowrap
  margin: 0 12px 12px 0
  color: var(--ant-color-text-base)
  position: relative
  overflow: hidden

  > .anticon
    margin: auto 0
    width: 28px
    height: 28px
    font-size: 28px
    flex: none
    border-radius: 14px
    color: var(--ant-color-primary)
    background-color: var(--ant-color-bg-base)

    &:hover
      background-color: var(--ant-color-bg-base)

  &.active
    border-color: var(--ant-color-primary)
    background-color: var(--ant-color-bg-base)

  &:hover
    border-color: var(--ant-color-primary)

  > span:last-child
    flex: 1
    margin: 0 12px
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    -webkit-box-orient: vertical
    -webkit-line-clamp: 1
</style>